module.exports = __webpack_public_path__ + "img/contact-logo.a1a72454.png";